import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { themeForThisVisit, writeActiveThemeCache, writeThemeRecord } from "./themes/themeCache";
// install bootstrap from getbootstrap.com
// npm install bootstrap
//copy path from node_modules bootstrap follder
// css file from bootstrap folder inside css folder
import "bootstrap/dist/css/bootstrap.min.css";
// js file from bootstrap folder inside js folder
import "bootstrap/dist/js/bootstrap.bundle.js";

const container = document.getElementById("root");

function apiBase() {
  const configured = process.env.REACT_APP_API_BASE_URL;
  return String(configured !== undefined ? configured : "http://localhost:8000").replace(/\/$/, "");
}

function fetchJson(url) {
  return fetch(url, { credentials: "omit" })
    .then((res) => (res.ok ? res.json() : null))
    .catch(() => null);
}

function primeStorefront() {
  const base = apiBase();
  const preview = new URLSearchParams(window.location.search).get("preview_theme");
  const themeUrl = preview
    ? `${base}/api/active-theme?preview_theme=${encodeURIComponent(preview)}`
    : `${base}/api/active-theme`;
  const themePromise = fetchJson(themeUrl).then((themeData) => {
    const theme = themeData && themeData.active_theme;
    if (theme && theme.theme_key && theme.settings) {
      if (preview) writeThemeRecord(theme);
      else writeActiveThemeCache(theme);
      window.__ECOM_ACTIVE_THEME__ = theme;
      return theme;
    }
    return null;
  });
  window.__ECOM_THEME_PROMISE__ = themePromise;
  window.__ECOM_THEME_PROMISE_KEY__ = preview || "";

  const settingsPromise = fetchJson(`${base}/api/settings`).then((settingsData) => {
    if (settingsData && settingsData.status === 200 && settingsData.settings) {
      window.__ECOM_STORE_SETTINGS__ = settingsData.settings;
      try {
        localStorage.setItem("store_settings", JSON.stringify(settingsData.settings));
      } catch (e) {}
      return settingsData.settings;
    }
    return null;
  });
  window.__ECOM_SETTINGS_PROMISE__ = settingsPromise;

  return Promise.all([themePromise, settingsPromise]).then(([theme, settings]) => {
    if (theme && theme.theme_key && theme.settings) {
      window.__ECOM_ACTIVE_THEME__ = theme;
    }
    if (settings) {
      window.__ECOM_STORE_SETTINGS__ = settings;
    }
  });
}

function mountApp() {
  const root = createRoot(container);
  root.render(<App callback={() => console.log("Rendered!")} />);
  reportWebVitals();
}

function mountWhenReady() {
  const path = window.location.pathname || "/";
  if (path.indexOf("/admin") === 0) {
    mountApp();
    return;
  }

  const theme = themeForThisVisit(window.__ECOM_ACTIVE_THEME__);
  const settings = window.__ECOM_STORE_SETTINGS__;
  if (theme && settings && (settings.storeName || settings.logoUrl)) {
    try {
      if (theme.is_preview) writeThemeRecord(theme);
      else writeActiveThemeCache(theme);
      localStorage.setItem("store_settings", JSON.stringify(settings));
    } catch (e) {}
    mountApp();
    return;
  }

  Promise.race([primeStorefront(), new Promise((resolve) => setTimeout(resolve, 4000))]).finally(mountApp);
}

mountWhenReady();
